export const DUPLICATE_INDEX_WORKER_NAME = "duplicate_index_worker";

export const DUPLICATE_INDEX_WORKER_DESC = `Duplicates an existing Index Worker.

Use when the user asks to duplicate/copy an Index Worker from the IW list More menu behavior.

Name resolution policy:
- If source project name + Index Worker name (+ destination project name for cross-project duplication) are provided, resolve IDs internally via available read tools (projectCatalog, list_index_workers) and then call this tool.
- Do not ask the user to manually confirm existence when you can verify by calling tools.
- Ask a clarification question only when name matching is ambiguous.

Input:
- 'indexWorkerId' (required): Source Index Worker ID.
- 'currentProjectId' (optional): Current Index Worker project ID of the source. Required when targetProjectId is omitted.
- 'targetProjectId' (optional): Destination project ID. If omitted, duplicates into the same project.
- 'organizationId' (optional): Workspace ID used only for building helper URLs.

Notes:
- Write operation (mutation).
- Returns helper links ('projectPath'/'projectUrl', 'indexWorkerPath'/'indexWorkerUrl') resolved from the tool result.
- Always use the returned links in your final response. Never construct links manually from IDs.`;
